import bubble from '../../assets/new-ui/coral/bubble.gif'

export default function Bubble(props) {
  const {top,bottom} = props
  return (
    <div className='coralGif bubble' style={{top:top,bottom:bottom}}>
      <img src={bubble} alt='bubble gif' />
    </div>
  )
}